import React, { useEffect, useState } from 'react';
import { IExtendedModuleProps } from '../../../core/types/IExtendedModuleProps';
import RestApiClient from '../../../core/api/RestApiClient';
import { ModuleNamesList } from '../../../core/lists/ModuleNamesList';
import TranslationService from '../../../core/services/TranslationService';
import { BootstrapTableContainer } from '../../../core/components/BootstrapTable/BootstrapTableContainer';
import { IComponentTable, emptyComponentTable } from '../../../core/types/IComponentTable';
import { GetUnitInvoicesResponse } from './types/GetUnitInvoicesResponse';
import RouteParamsService from '../../../core/services/RouteParamsService';
import Footer from './components/Footer';
import TableConfigurator from './helpers/TableConfigurator';
import { UnitInvoice } from './types/UnitInvoice';
import Loader from '../../../core/components/Loading/Loader';
import NoPermissionsComponent from '../../../core/components/NoPermissionsComponent/NoPermissionsComponent';
import { withRouter, RouteComponentProps } from 'react-router';
import { Button, BUTTON_VARIANTS, BUTTON_SIZE } from '../../../core/components/Button/Button';

const getUnitIdInvoicesUrl = 'modules/UnitInvoicesModule/{moduleInstanceId}/{creditorNo}/{accountNo}/{unitId}'

const CreditorDebtorUnitCases = (props: IExtendedModuleProps & RouteComponentProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const [hasAccess, setHasAccess] = useState(true);
  const [table, setTable] = useState<IComponentTable<UnitInvoice>>(emptyComponentTable)

  const [summaryCounters, setSummaryCounters] = useState({
    totalInvoices: 0,
    totalBalance: 0,
    totalCapital: 0,
  })

  const loadData = async () => {
    setIsLoading(true);
    const queryParams = RouteParamsService.getQueryParameters();
    const properUrl = getUnitIdInvoicesUrl
      .replace('{moduleInstanceId}', props.module.id.toString())
      .replace('{creditorNo}', queryParams.creditorNo as string)
      .replace('{accountNo}', queryParams.accountNo as string)
      .replace('{unitId}', (queryParams.unitId !== undefined ? queryParams.unitId : '') as string);

    try {
      const data = await RestApiClient.get<GetUnitInvoicesResponse>(properUrl)

      setTable(data.table);

      setSummaryCounters({
        totalInvoices: data.totalInvoices,
        totalBalance: data.totalBalance,
        totalCapital: data.totalCapital
      })
    } catch (err) {
      if (err.response && err.response.status === 403) {
        setHasAccess(false);
      }
    }

    setIsLoading(false);
  }

  // eslint-disable-next-line
  useEffect(() => { loadData() }, [props]);

  if (!hasAccess) {
    return <NoPermissionsComponent />
  }

  return (
    <article className="l-module">
      <Loader isLoaded={!isLoading} opacity={0.5} />
      <section className="l-module__section l-module__section--head">
        <h1 className="l-module__title">
          <i className="fas fa-file-invoice" />
          {TranslationService.translateModule('UnitIdDetails', ModuleNamesList.UnitInvoices)}:
          <strong className="l-module__title-highlighted">
            {TranslationService.translateModule('Invoices', ModuleNamesList.UnitInvoices)}
          </strong>
        </h1>
      </section>

      <section className='l-module__section  mt-3'>
        <div className="unit-invoices__action-btns">
          <Button
            variant={BUTTON_VARIANTS.PRIMARY}
            size={BUTTON_SIZE.MD}
            icon={{
              position: 'left',
              className: 'fas fa-arrow-left'
            }}
            label={TranslationService.translate('Back')}
            onClick={() => {
              props.history.goBack();
            }} />
        </div>
        <BootstrapTableContainer
          remote={false}
          data={table.values}
          classes="bt__table bt-table"
          keyField="docNo"
          wrapperClasses="bt unit-invoices-table"
          columns={TableConfigurator.getTableColumns(table)}
        />
      </section>
      <section className="l-module__section l-module__section--p-0 mt-3">
        <Footer
          totalBalance={summaryCounters.totalBalance}
          totalInvoices={summaryCounters.totalInvoices}
          totalCapital={summaryCounters.totalCapital} />
      </section>
    </article>
  )
}

export default withRouter(CreditorDebtorUnitCases);